import {useState } from "react";

import Customer from "../../components/report/Customer";
import Sales from "../../components/report/Sales";
import ProductsReport from "../../components/report/ProductsReport";
import OrdersReport from "../../components/report/OrderReport";
import Finance from "../../components/report/Finance";
import Marketing from "../../components/report/Marketing";
import VendorReport from "../../components/report/VendorReport";
import InventoryReport from "../../components/report/InventoryReport";

const Report = () => {
  const [selected, setSelected] = useState("");
  const components = {
    customer: <Customer />,
    sales: <Sales />,
    product: <ProductsReport />,
    order: <OrdersReport />,
    finance: <Finance />,
    marketing: <Marketing />,
    vendor: <VendorReport />,
    inventory:<InventoryReport/>,
    
  };

  return (
    <div className="container mt-4">
      <select
        className="form-select"
        value={selected}
        onChange={(e) => setSelected(e.target.value)}
      >
        <option value="">-- Select Report --</option>
        <option value="customer">Customers Report</option>
        <option value="sales">Sales Report</option>
        <option value="product">Product Report</option>
        <option value="order">Order Report</option>
        <option value="finance">Finance Report</option>
        <option value="marketing">Marketing Report</option>
        <option value="vendor">Vendor Report</option>
        <option value="inventory">Inventory Report</option>
      </select>

      <div className="mt-3">
        {selected ? (
          components[selected]
        ) : (
          <p className="text-muted">Choose a report to display</p>
        )}
      </div>
    </div>
  );
};

export default Report;
